<template>
    <div>
        <h2 style="text-align: center">การชำระเงิน</h2>
        <br/>
        <div class="form-group row">
            <label
                class="col-sm-4 col-form-label text-capitalize text-right">ยอดที่ต้องชำระ</label>
            <div class="col-sm-6">
                <input type="number" class="form-control" v-model="form.total"/>
            </div>
        </div>
        <div class="form-group row">
            <label
                class="col-sm-4 col-form-label text-capitalize text-right">เงินสด</label>
            <div class="col-sm-6">
                <input type="number" class="form-control" v-model="form.amount"/>
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" type="button" @click="submitData">
                <icon name="save"></icon>
                บันทึก
            </button> &nbsp;
            <button class="btn btn-outline-secondary" type="button" @click="cancelData">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "TransactionModal",
        created() {
        },
        computed:{
            ...mapState({
                form : state=>{
                    return state.FactoryEmployeeSale.form
                },
                user : state=>{
                    return state.Auth.user;
                },
            })
        },
        methods:{
            cancelData(){
                this.$emit("submit",false);
            },
            submitData(){
                if(parseFloat(this.form.amount) !== parseFloat(this.form.total)){
                    alert("คุณชำระเงินไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง");
                }else{
                    this.$emit("submit",true);
                }
            }
        },
    }
</script>

<style scoped>

</style>
